<template>
    <v-container fluid>
        <v-row>
            <v-col cols="1">
                <v-img :src="marca.imagen" aspect-ratio="1" />
            </v-col>
            <v-col cols="11">
                <h1>{{ (marca && marca.nombre) ? marca.nombre : $route.params.nomenclatura }}</h1>
                <hr/>
            </v-col>
        </v-row>

        <v-row v-if="marca && marca.nombre">
            <v-col cols="12">
                <v-container fluid class="px-0">
                    <v-row v-for="familia in familiasPorMarca(marca)" :key="familia.id">
                        <v-col cols="12">
                            <router-link tag="h3" class="text-decoration-underline pointer" :to="{ path: `/tiposFamilias/${familia.nomenclatura}` }">
                                {{ familia.nombre }}
                            </router-link>
                            <hr />
                        </v-col>

                        <v-container fluid>
                            <v-row>
                                <v-col class="fill-height" cols="6" lg="2" v-for="herramienta in herramientasPorMarcaYFamilia(marca.id, familia.id)" :key="herramienta.id">
                                    <Herramienta :herramienta="herramienta" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Herramienta from "@/components/Herramienta";

export default {
  name: "Marca",
  components: { Herramienta },
  data() {
    return {
      loaded: false,
      marca: []
    }
  },
  computed: {
    ...mapGetters(['marcaPorNomenclatura', 'familiasPorMarca', 'herramientasPorMarcaYFamilia'])
  },
  methods: {
    ...mapActions(['obtenerMarcas', 'obtenerFamilias', 'obtenerHerramientas'])
  },
  mounted() {
    this.obtenerHerramientas().then(() => {
      this.marca = this.marcaPorNomenclatura(this.$route.params.nomenclatura)
      this.loaded = true;
      console.log("loaded");
    });
  }
}
</script>

<style scoped>

</style>
